//Module Keys
let locales = {};

//Merge Views
import login from 'Core/views/login/lan/es';
locales = { ...locales, ...login };

import loginSocialMedia from 'Core/views/loginSocialMedia/lan/es';
locales = { ...locales, ...loginSocialMedia };

import forgotPasswordOld from 'Core/views/login/.components/forgotPassword/lan/es';
locales = { ...locales, ...forgotPasswordOld };

import changePassword from 'Core/containers/Header/.components/changePassword/lan/es';
locales = { ...locales, ...changePassword };

import forceChangePassword from 'Core/views/login/.components/chagePassword/lan/es';
locales = { ...locales, ...forceChangePassword };

import menuAccount from 'Core/containers/Header/.components/menuAccount/lan/es';
locales = { ...locales, ...menuAccount };

import confirmUser from 'Core/views/confirmUser/lan/es';
locales = { ...locales, ...confirmUser };

import forgotPassword from 'Core/views/forgotPassword/lan/es';
locales = { ...locales, ...forgotPassword };

import logoutPrompt from 'Core/containers/Header/.components/logoutPrompt/lan/es';
locales = { ...locales, ...logoutPrompt };

export default locales;